/* eslint-disable react/no-danger */
import React, { useEffect, useRef, useState } from 'react';

import Link from 'next/link';
import PropTypes from 'prop-types';
import Marquee from 'react-double-marquee';
import { useRecoilValue } from 'recoil';

import useI18n from '../../hooks/use-i18n';
import { config } from '../../recoil/atoms/config';
import JpHomePageSubbar from '../includes/jp-homepage-subbar';

import '../../styles/jp-revamp/jp-header.scss';

const JpHeader = (props) => {
  const { page } = props;
  const i18n = useI18n();

  const orientationMsg = i18n.t('orientation');

  const configData = useRecoilValue(config);
  const dropdown = useRef();
  const [isNotification, toggleIsNotification] = useState(false);
  const [isSticky, toggleIsSticky] = useState(false);
  const [isOverflow, setIsOverflow] = useState(false);

  const scrollEventListner = () => {
    toggleIsSticky(window.pageYOffset > 80);
  };

  useEffect(() => {
    const { body } = document;
    const scrollUp = 'scroll-up';
    const scrollDown = 'scroll-down';
    let lastScroll = 0;

    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll <= 0) {
        body.classList.remove(scrollUp);
        return;
      }
      if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
        body.classList.remove(scrollUp);
        body.classList.add(scrollDown);
      } else if (
        currentScroll < lastScroll
            && body.classList.contains(scrollDown)
      ) {
        body.classList.remove(scrollDown);
        body.classList.add(scrollUp);
      }
      lastScroll = currentScroll;
    });
  });

  useEffect(() => {
    window.addEventListener('scroll', scrollEventListner);
    document.addEventListener('mousedown', handleClick);
    return () => {
      window.removeEventListener('scroll', scrollEventListner);
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  useEffect(() => {
    setIsOverflow(document.querySelector('.product-notify-bar p')?.offsetWidth > window.innerWidth);
    toggleIsNotification(document.querySelector('.product-notify-bar'));
  }, [configData]);

  const handleClick = (e) => {
    if (dropdown.current && dropdown.current.contains(e.target)) {
      return false;
    }
    return true;
  };

  const headerClass = [isSticky && 'sticky', !isNotification && 'disable-notify-bar'].filter((e) => !!e).join(' ');

  return (
    <header className={`${headerClass} jp-header`}>
      {configData.notifyMessage && (
        <div className={`top-notify-bar product-notify-bar ${isOverflow ? '' : 'no-overflow'}`}>
          <div className="container">
            <Marquee direction="left" speed={0.03}>
              <p
                dangerouslySetInnerHTML={{ __html: configData.notifyMessage }}
              />
            </Marquee>
          </div>
        </div>
      )}
      <div className="logo-wrapper">
        <Link href="/[lng]/" as={`/${i18n.activeLocale}/`}>
          <a
            className="nav-logo"
            role="presentation"
          >
            <img src="/img/logo-new.svg" data-gumlet="false" alt="Zenyum Logo" />
          </a>
        </Link>
      </div>
      <div className="orientation-msg">
        <div>
          <h2>{orientationMsg.title}</h2>
          <p>{orientationMsg.description}</p>
        </div>
      </div>
      {page === 'Home' && <JpHomePageSubbar />}
    </header>
  );
};

export default JpHeader;

JpHeader.propTypes = {
  page: PropTypes.string
};
JpHeader.defaultProps = {
  page: ''
};
